<script>
import Header from '@/components/app/shared/flight-sharing/Header'
import AircraftRate from '@/components/app/shared/flight-sharing/AircraftRate'
import ExampleEarnings from '@/components/app/shared/flight-sharing/ExampleEarnings'
import Instructions from '@/components/app/shared/flight-sharing/Instructions'
import Faq from '@/components/app/shared/flight-sharing/Faq'

export default {
  components: { Header, AircraftRate, ExampleEarnings, Instructions, Faq },
}
</script>

<template>
	<section class="pt-10 md:pt-14 px-6 sm:px-8 md:px-28 pb-12 md:pb-24 flex flex-col items-center bg-cream-100">
		<Header />
		<div
			class="max-w-screen-xl mt-12 p-8 md:p-24 md:pt-12 flex flex-col"
			style="background-color: #FBFAF9; border-radius: 16px;"
		>
			<h3
				class="text-grey-700 text-center font-header font-semibold leading-tight"
				style="font-size: 28px;"
			>Pricing</h3>
			<div class="mt-14 self-center flex flex-wrap md:grid grid-cols-3 col-gap-20 row-gap-14 justify-center">
				<AircraftRate
					icon="PC12"
					name="Pilatus PC-12"
					:perHour="830"
				/>
				<AircraftRate
					icon="PC24"
					name="Pilatus PC-24"
					:perHour="1000"
				/>
				<AircraftRate
					icon="SF50"
					name="Cirrus JET"
					:perHour="1125"
				/>
			</div>
			<div class="self-center md:self-auto mt-24 md:mt-28 flex flex-col gap-4">
				<h4
					class="self-center md:self-auto md:ml-8 lg:ml-16 text-grey-700 font-header text-lg font-medium leading-tight tracking-widest uppercase"
				>Some examples</h4>
				<div
					class="pt-5 px-8 lg:px-16 pb-8 flex flex-col md:flex-row justify-between gap-4 bg-cream-100"
					style="border-radius: 16px;"
				>
					<ExampleEarnings
						from="Paris Le Bourget"
						to="Geneva"
						aircraft="Pilatus PC-12"
						:minutes="67"
						:perSeat="930"
					/>
					<div
						class="h-px md:h-auto md:w-px"
						style="background-color: #E7E2D6"
					/>
					<ExampleEarnings
						from="London City Airport"
						to="Milan Linate"
						aircraft="Pilatus PC-24"
						:minutes="75"
						:perSeat="1250"
					/>
					<div
						class="h-px md:h-auto md:w-px"
						style="background-color: #E7E2D6"
					/>
					<ExampleEarnings
						from="Luxembourg"
						to="Saint-Tropez La Môle"
						aircraft="Cirrus Jet"
						:minutes="97"
						:perSeat="1820"
					/>
				</div>
			</div>
			<Instructions class="mt-24 lg:mt-48" />
			<Faq class="mt-24 lg:mt-40" />
		</div>
	</section>
</template>